import {createSelector} from 'reselect'

const stateReducer = state => state.verifyReducer;

export const selectFetching = (initData) =>
    createSelector(
        stateReducer,
        verifyReducer => verifyReducer.isFetching
    )

export const selectErrors = (initItems) =>
    createSelector(
        stateReducer,
        verifyReducer => verifyReducer.errors
    )

export const selectVerifyGeneral = (initItems) =>
    createSelector(
        stateReducer,
        verifyReducer => verifyReducer.general
    )
